module.exports = __webpack_public_path__ + "static/media/modal_rank_close.0632220d.png";